<template>
  <div>
    <div
      style="
        color: #999;
        width: 100%;
        position: fixed;
        bottom: 0;
        padding: 12px 24px;
        font-size: 12px;
        text-align: center;
      "
    >
      宋志海玉雕工作室
    </div>
    <a-modal
      v-model="show"
      title="声明"
      centered
      okText="确定"
      cancelText="取消"
      @ok="
        () => {
          this.show = false;
        }
      "
    >
      <p>
        艺瑾杯由苏州工业园区萃玉工艺美术中心举办、苏州工业园区萃玉工艺美术中心内部评奖，主办方享有最终解释权。
      </p>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>